<template>
    <div class="card">
        <div class="card-header">
          <button @click="() => open = !open" class="btn" type="button" data-toggle="collapse" data-target="#taxTypeCollapse" aria-expanded="false" aria-controls="taxTypeCollapse">
            <i v-if="open" class="fas fa-angle-up"></i>
            <i v-else class="fas fa-angle-down"></i>
            <h4 data-target="#taxTypeCollapse" aria-expanded="false" aria-controls="taxTypeCollapse" class="btn alert-heading font-18 text-dark">Նշել հարկատեսակը</h4>
          </button>
        </div>
        <div id="taxTypeCollapse" class="collapse multi-collapse">
          <div class="card-body d-flex flex-column">
              <p class="text-muted">
                  Հետագա խնդիրներից խուսափելու համար, խնդրում ենք ճիշտ նշել հարկատեսակը։
              </p>
              <div class="p-3">
                  <form class="form-parsley" action="#" novalidate="">
                      <div class="form-group radio">
                          <input v-model="vat_payer_type" type="radio" id="inlineRadio1" value="payer" name="radioInline" checked="">
                          <label for="inlineRadio1">ԱԱՀ վճարող *</label>
                      </div>
                      <div class="form-group radio">
                          <input v-model="vat_payer_type" type="radio" id="inlineRadio2" value="not_payer" name="radioInline">
                          <label for="inlineRadio2">ԱԱՀ չվճարող *</label>
                      </div>
                      <div class="radio">
                          <input v-model="vat_payer_type" type="radio" id="inlineRadio3" value="payer_with_but" name="radioInline">
                          <label for="inlineRadio3">ԱԱՀ-ով աշխատող, սակայն հաղթողը որոշվում է հատուցման գումարով *</label>
                      </div>
                  </form>
              </div>
              <div class="bg-white w-100 pr-0 text-right" style="bottom: 0">
                <button @click="save" type="button" class="btn btn-primary  waves-effect waves-light float-right" data-toggle="modal" data-animation="bounce">
                    Պահպանել
                </button>
              </div>
          </div>
        </div>
    </div>
</template>


<script>
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'taxType',
  data () {
    return {
      open: false,
      vat_payer_type: '',
    }
  },
  validations: {
    fields: {
      vat_payer_type: { required },
    },
  },
  computed: {
    isCoordinator(){
       return +this.me.divisions === 2
    },
    me() {
      return this.$store.getters['user/me']
    },
  },
  created(){
    this.vat_payer_type = this.me.vat_payer_type;
  },
  watch: {
    me(newValue, oldValue) {
      this.vat_payer_type = newValue.vat_payer_type;
    },
  },
  methods: {
    consoleLog(e){
      console.log(e)
    },
    save() {
      $client.put(`user`, {vat_payer_type: this.vat_payer_type}).then(({data}) => {
            if(data.data){
                this.$notify({
                    group: 'foo',
                    type: 'success',
                    text: 'Հաջողությամբ պահպանված է'
                })
            }
        }).catch(e => {
            this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Էլ. հացեն զբաղված է',
            text: 'Կրկին փորձեք!'
            })
        })
    },
  },
}
</script>
